import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IValidacionFormulario } from "./IValidacionFormulario-interface";


@Injectable({
  providedIn: "root",
})
export class ValidacionTrabajadorService implements IValidacionFormulario {
  private controlNamesPrincipal = [
    "NumIdTrabajador",
    "TipoIdTrabajador",
    "GeneroTrabajador",
    "FechaNaciTrabajador",
    "Apellido1Trabajador",
    "Apellido2Trabajador",
    "Nombre1Trabajador",
    "Nombre2Trabajador",
    "NacionalidadTrabajador",
    "EstadoCivilTrabajador",
    "DepartamentoResTrabajador",
    "CiudadResTrabajador",
  ];

  validar(form: FormGroup): void {
    this.disableExcluded(form);
    form.get("EsValido")?.setValue(true);
  }

  private disableExcluded(form: FormGroup): void {
    if (!form) return;

    Object.keys(form.controls).forEach((controlName) => {
      if (this.controlNamesPrincipal.includes(controlName)) {
        form.get(controlName)?.disable();
      }
    });
  }
}
